export default __webpack_public_path__ + "static/media/arrow.b986a702.svg";